import React from "react";
import { Container } from "react-bootstrap";

export default function LeadooForm() {
  return (
    <Container>
     <ld-slot name="Contact Us" ></ld-slot>
    </Container>
  );
}
